import { Person } from '../swagger';

export const breakdownPersons = (persons: Person[]) => ({
  main: persons.find((pr) => pr.type === Person.TypeEnum.Main),
  spouse: persons.find((pr) => pr.type === Person.TypeEnum.Spouse),
  children: persons.filter((pr) => pr.type === Person.TypeEnum.Child),
});
